var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrivacyPolicy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9987 19.4669C9.09036 19.4669 8.19036 19.2002 7.48203 18.6752L3.8987 16.0002C2.9487 15.2919 2.20703 13.8085 2.20703 12.6335V6.43353C2.20703 5.1502 3.1487 3.78353 4.35703 3.33353L8.51536 1.7752C9.34036 1.46686 10.6404 1.46686 11.4654 1.7752L15.6237 3.33353C16.832 3.78353 17.7737 5.1502 17.7737 6.43353V12.6252C17.7737 13.8085 17.032 15.2835 16.082 15.9919L12.4987 18.6669C11.807 19.2002 10.907 19.4669 9.9987 19.4669ZM8.95703 2.9502L4.7987 4.50853C4.09036 4.7752 3.46536 5.6752 3.46536 6.44186V12.6335C3.46536 13.4252 4.0237 14.5335 4.6487 15.0002L8.23203 17.6752C9.19036 18.3919 10.807 18.3919 11.7737 17.6752L15.357 15.0002C15.9904 14.5252 16.5404 13.4252 16.5404 12.6335V6.43353C16.5404 5.6752 15.9154 4.7752 15.207 4.5002L11.0487 2.94186C10.482 2.74186 9.51536 2.74186 8.95703 2.9502Z",
    fill: "#30322C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacyPolicy);
export default __webpack_public_path__ + "static/media/privacyPolicy.35b116d7d694dfe90d9f4b5cd5ee87f1.svg";
export { ForwardRef as ReactComponent };